import { render, staticRenderFns } from "./UserAnnouncement.vue?vue&type=template&id=27e23c6e&"
import script from "./UserAnnouncement.vue?vue&type=script&lang=js&"
export * from "./UserAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports